import { UnstyledButton } from "@classdojo/web";
import { CloseIcon } from "@classdojo/web/nessie/icons";
import translate from "../../utils/translate";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
export var CloseButton = function CloseButton(_ref) {
  var onClick = _ref.onClick;
  return _jsx(UnstyledButton, {
    sx: {
      position: "absolute",
      top: "50%",
      right: "dt_s",
      transform: " translateY(-50%)"
    },
    "aria-label": translate({
      str: "dojo.common:actions.close_dialog",
      fallback: "Close dialog"
    }),
    onClick: onClick,
    children: _jsx(CloseIcon, {
      size: "s",
      color: "dt_white",
      sx: {
        verticalAlign: "middle"
      }
    })
  });
};